export default {
  root: {
    padding: '8px'
  }
};
